import { makeStyles } from '@material-ui/core/styles';
import fonts from 'styles/fonts';
import { colors } from 'styles/colors';

const useStyles = makeStyles({
  presentation: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  modalPresentation: {
    outline: 'none',
  },
  modalCard: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    background: colors.white,
    boxShadow:
      '0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2)',
    width: 516,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: 12,
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 24px',
    alignItems: 'center',
    height: '67px',
    width: '100%',
    borderBottom: `1px solid ${colors.lightGray}`,
  },
  headerTitle: {
    fontSize: fonts.sizes.medium,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '24px',
    color: colors.black,
  },
  headerIcon: {
    cursor: 'pointer',
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: '32px 24px',
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    height: '64px',
    padding: '0px 24px',

    '& > *:first-child': {
      marginRight: '16px',
    },
  },
  bodyText: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
    color: '#000000',
    marginBottom: '0px',
  },
  dropzone: {
    display: 'flex',
    justifyContent: 'center',
    margin: '0px 24px 8px 24px',
    border: '1px dashed',
    padding: '20px',
    color: 'rgba(0, 0, 0, 0.12)',
  },
  format: {
    marginLeft: '40px',
    color: '#00000099',
  },
  backupIcon: {
    marginRight: '16px',
    marginTop: '-4px',
    color: colors.primary,
  },
  chooseFile: {
    color: colors.primary,
    marginRight: '4px',
    fontSize: '14px',
  },
  dragHere: {
    color: 'black',
    fontSize: '14px',
  },
});

export default useStyles;
